let createFreightRule = (
    senderId,
    name,
    paymentCountryId,
    order,
    isActive,
    parameterIds,
    operatorIds,
    values,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    let data = {
        senderId: senderId,
        name: name,
        paymentCountryId: paymentCountryId,
        order: order,
        isActive: Number(isActive),
    };

    parameterIds.forEach(function (parameterId, index) {
        data["parameterId" + index] = parameterId;
    });

    operatorIds.forEach(function (operatorId, index) {
        data["operatorId" + index] = operatorId;
    });

    values.forEach(function (value, index) {
        data["value" + index] = value;
    });

    data["countConditions"] = parameterIds.length;

    $.post({cache: false, url: '/freight-rule/create-freight-rule', data: data})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let editFreightRule = (
    freightRuleId,
    name,
    paymentCountryId,
    order,
    isActive,
    parameterIds,
    operatorIds,
    values,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    let data = {
        name: name,
        paymentCountryId: paymentCountryId,
        order: order,
        isActive: Number(isActive),
    };

    parameterIds.forEach(function (parameterId, index) {
        data["parameterId" + index] = parameterId;
    });

    operatorIds.forEach(function (operatorId, index) {
        data["operatorId" + index] = operatorId;
    });

    values.forEach(function (value, index) {
        data["value" + index] = value;
    });

    data["countConditions"] = parameterIds.length;

    $.post({cache: false, url: '/freight-rule/edit-freight-rule?id=' + freightRuleId, data: data})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let freightRuleOrderUp = (
    freightRuleId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: '/freight-rule/freight-rule-up?id=' + freightRuleId, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let freightRuleOrderDown = (
    freightRuleId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: '/freight-rule/freight-rule-down?id=' + freightRuleId, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let disableFreightRule = (
    freightRuleId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: '/freight-rule/disable-freight-rule?id=' + freightRuleId, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let enableFreightRule = (
    freightRuleId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: '/freight-rule/enable-freight-rule?id=' + freightRuleId, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let deleteFreightRule = (
    freightRuleId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.ajax({
        cache: false,
        method: 'DELETE',
        url: '/freight-rule/delete-freight-rule?id=' + freightRuleId,
        data: {}
    })
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let getCountObjectsByFreightRule = (
    freightRuleId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: '/freight-rule/get-count-object-by-freight-rule?id=' + freightRuleId, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let applyFreightRule = (
    freightRuleId,
    successAction = (response, textStatus, jqXHR) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Action failed\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: '/freight-rule/apply-freight-rule?id=' + freightRuleId, data: {}})
        .done(function (response, textStatus, jqXHR) {
            successAction(response, textStatus, jqXHR);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};
